import { useSelector } from 'react-redux'

import { selectUnvisitedUpsellPages } from 'root-redux/selects/common'
import { selectHasAccessToAppByEmail } from 'root-redux/selects/user'

import { PageId } from 'page-constants'
import { TEST_SEGMENTS } from 'root-constants'

import { useExperimentalFeatures } from './useExperimentalFeatures'
import { useIsUsGeoCohort } from './useIsUsGeoCohort'

export const useAvailableUpsellPages = (): string[] => {
  const unvisitedUpsellPages = useSelector(selectUnvisitedUpsellPages)
  const hasAccessToApp = useSelector(selectHasAccessToAppByEmail)
  const shouldSkipUpsellForUser = useIsUsGeoCohort()
  const { ayah98AudioUpsellVariant } = useExperimentalFeatures()

  if (shouldSkipUpsellForUser || hasAccessToApp) {
    return []
  }

  return unvisitedUpsellPages.filter((pageId) => {
    if (pageId === PageId.INAPP_VOICEOVER) {
      return ayah98AudioUpsellVariant === TEST_SEGMENTS.VARIANT_D
    }

    if (pageId === PageId.INAPP_VOICEOVER_V3) {
      return (
        ayah98AudioUpsellVariant === TEST_SEGMENTS.VARIANT_B ||
        ayah98AudioUpsellVariant === TEST_SEGMENTS.VARIANT_C
      )
    }

    return true
  })
}
